<template>
	<div class="main">
		<div class="naverwebtoon">
			<img class="close b-close" src="../assets/image/close.png" alt="">
			<a href=""><img src="../assets/image/naverwebtoon_bigbanner.png" alt=""></a>
		</div>
		<div class="box box-waro">
			<Header></Header>
			<img class="loading" :src="gameData.topBgImage" alt="">
			<div class="item_welfare">
				<div class="content">
					<UserInfo ref="userInfo"></UserInfo>
					<div class="describe">
						<img src="../assets/warorderimg/push.png" alt="">
						<span>|</span>
						<p class="marquee"><span>Find more Top-up benefits in the Official Website. If you have any
								problems, Please
								contact customer service.</span></p>
					</div>
					<div class="position-war">
						<div class="icon">
							<div class="Purchased">
								<img :class="haveBuy ? '' : 'animation'" src="../assets/warorderimg/gift.png" alt="">
								<p v-on:click="openConfirmOrderWindow()" :class="haveBuy ? '' : 'animation'">{{ buyText }}
								</p>
							</div>
						</div>
						<div class="conter">
							<div class="conter-left">
								<div class="Daily">Daily Login rewards</div>
								<ul>
									<li v-on:click="receive(0, statusObject[0].status)"
										:class="[statusObject[0].class]">
										<div v-if="statusObject[0].received"
											:class="statusObject[0].received ? 'active' : ''">
											<img src="../assets/warorderimg/miaomi.png" alt="">
										</div>
									</li>
									<li v-on:click="receive(1, statusObject[1].status)"
										:class="[statusObject[1].class]">
										<div v-if="statusObject[1].received"
											:class="statusObject[1].received ? 'active' : ''">
											<img src="../assets/warorderimg/miaomi.png" alt="">
										</div>
									</li>
									<li v-on:click="receive(2, statusObject[2].status)"
										:class="[statusObject[2].class]">
										<div v-if="statusObject[2].received"
											:class="statusObject[2].received ? 'active' : ''">
											<img src="../assets/warorderimg/miaomi.png" alt="">
										</div>
									</li>
									<li v-on:click="receive(3, statusObject[3].status)"
										:class="[statusObject[3].class]">
										<div v-if="statusObject[3].received"
											:class="statusObject[3].received ? 'active' : ''">
											<img src="../assets/warorderimg/miaomi.png" alt="">
										</div>
									</li>
									<li v-on:click="receive(4, statusObject[4].status)"
										:class="[statusObject[4].class]">
										<div v-if="statusObject[4].received"
											:class="statusObject[4].received ? 'active' : ''">
											<img src="../assets/warorderimg/miaomi.png" alt="">
										</div>
									</li>
									<li v-on:click="receive(5, statusObject[5].status)"
										:class="[statusObject[5].class]">
										<div v-if="statusObject[5].received"
											:class="statusObject[5].received ? 'active' : ''">
											<img src="../assets/warorderimg/miaomi.png" alt="">
										</div>
									</li>
									<li v-on:click="receive(6, statusObject[6].status)"
										:class="[statusObject[6].class]">
										<div v-if="statusObject[6].received"
											:class="statusObject[6].received ? 'active' : ''">
											<img src="../assets/warorderimg/miaomi.png" alt="">
										</div>
									</li>
								</ul>
							</div>
							<div class="days"></div>
							<div class="conter-right">
								<div class="Super">Super Value Pack</div>
								<ul>
									<li v-on:click="receive(10, statusObject[10].status)"
										:class="[statusObject[10].class]">
										<div v-if="statusObject[10].received"
											:class="statusObject[10].received ? 'active' : ''">
											<img src="../assets/warorderimg/miaomi.png" alt="">
										</div>
									</li>
									<li v-on:click="receive(11, statusObject[11].status)"
										:class="[statusObject[11].class]">
										<div v-if="statusObject[11].received"
											:class="statusObject[11].received ? 'active' : ''">
											<img src="../assets/warorderimg/miaomi.png" alt="">
										</div>
									</li>
									<li v-on:click="receive(12, statusObject[12].status)"
										:class="[statusObject[12].class]">
										<div v-if="statusObject[12].received"
											:class="statusObject[12].received ? 'active' : ''">
											<img src="../assets/warorderimg/miaomi.png" alt="">
										</div>
									</li>
									<li v-on:click="receive(13, statusObject[13].status)"
										:class="[statusObject[13].class]">
										<div v-if="statusObject[13].received"
											:class="statusObject[13].received ? 'active' : ''">
											<img src="../assets/warorderimg/miaomi.png" alt="">
										</div>
									</li>
									<li v-on:click="receive(14, statusObject[14].status)"
										:class="[statusObject[14].class]">
										<div v-if="statusObject[14].received"
											:class="statusObject[14].received ? 'active' : ''">
											<img src="../assets/warorderimg/miaomi.png" alt="">
										</div>
									</li>
									<li v-on:click="receive(15, statusObject[15].status)"
										:class="[statusObject[15].class]">
										<div v-if="statusObject[15].received"
											:class="statusObject[15].received ? 'active' : ''">
											<img src="../assets/warorderimg/miaomi.png" alt="">
										</div>
									</li>
									<li v-on:click="receive(16, statusObject[16].status)"
										:class="[statusObject[16].class]">
										<div v-if="statusObject[16].received"
											:class="statusObject[16].received ? 'active' : ''">
											<img src="../assets/warorderimg/miaomi.png" alt="">
										</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer></Footer>
		</div>
		<TipsWindow ref="tips"></TipsWindow>
		<ConfirmOrder v-if="hasLogin" :goods="goods" :rebate="rebate"></ConfirmOrder>
	</div>
</template>

<script>
import Header from '../components/header.vue'
import Footer from '../components/footer.vue'
import UserInfo from '../components/userInfo.vue'
import TipsWindow from '../components/tipsWindow.vue'
import ConfirmOrder from '../components/confirmOrder.vue'
import {
	isEmpty,
	isNotEmpty
} from '../utils/index.js'
export default {
	name: 'welfare',
	components: {
		Header,
		Footer,
		UserInfo,
		TipsWindow,
		ConfirmOrder
	},
	data() {
		return {
			show: false,
			goods: {
				"amount": 4.99,
				"productId": "com.msg.enwebdrzl",
				"icon": "https://cdn-download.tthplay.com/image/cms/20250212/20bf96b60da248f5bb10907abc4d59d4.png",
				"currency": "USD",
				"tips": "Super Value Pack",
				"buttonText": "USD 4.99",
				"describe": "Super Value Pack",
				"status": 1
			},
			rebate: {
				"rebate": 0,
				"tips": "Find more Top-up benefits in the Official Website. If you have any problems, Please contact customer service."
			},
			actCode: 'sevenDayPass',
			gameData: this.$store.state.gameData,
			haveBuy: false,
			buyText: '$4.99',
			statusObject: {},
			hasLogin: this.$session.hasLogin()
		}
	},
	mounted() {
		for (let i = 0; i < 17; i++) {
			if (i <= 6 || i >= 10)
				this.$set(this.statusObject, i, {
					status: 0,
					class: 'button_active',
					received: false
				})
		}
		this.initActivityData();
	},
	methods: {
		initActivityData: function () {
			if (this.$session.hasLogin()) {
				this.$axios({
					method: 'get',
					url: '/web/api/sevenDay/initData',
					params: {
						actCode: this.actCode,
						userId: this.$session.getUserId(),
						gameCode: this.$cache.getGameCode(),
					}
				})
					.then(response => {
						if (response.code === 1000) {
							let data = response.data;
							this.haveBuy = data.haveBuy;
							this.buyText = this.haveBuy ? 'Purchased' : this.buyText;
							let _this = this;
							data.meetLevel.forEach(function (level) {
								_this.statusObject[level].status = 1;
								_this.statusObject[level].class = '';
								let received = false;
								if (isNotEmpty(data.rewardList[level])) {
									_this.statusObject[level].status = 2;
									received = true;
									_this.statusObject[level].received = true;
								}
								if (_this.haveBuy) {
									_this.activeSuperValuePack(_this, data, level, received);
								}
							});
						}
					})
			}
		},
		activeSuperValuePack: function (_this, data, level, received) {
			level = level + 10;
			if (isNotEmpty(data.meetLevel[level]) && received) {
				_this.statusObject[level].status = 1;
				_this.statusObject[level].class = '';
			}
			if (isNotEmpty(data.rewardList[level])) {
				_this.statusObject[level].status = 2;
				_this.statusObject[level].received = true;
			}
		},
		receive: function (level, status) {
			if (status != 1) return;
			let _role = this.$cache.getRoleInfo();
			if (isEmpty(_role)) {
				this.$refs.userInfo.openRoleChooseWindow();
				return;
			}
			this.$axios({
				method: 'get',
				url: '/web/api/sevenDay/receive',
				params: {
					actCode: this.actCode,
					userId: this.$session.getUserId(),
					gameCode: this.$cache.getGameCode(),
					serverCode: _role.serverCode,
					roleId: _role.roleId,
					level: level
				}
			})
				.then(response => {
					if (response.code === 1000) {
						this.statusObject[level].class = '';
						this.statusObject[level].status = 2;
						this.statusObject[level].received = true;
						if (level < 7 && this.haveBuy) {
							this.statusObject[level + 10].class = '';
							this.statusObject[level + 10].status = 1;
						}
						this.$refs.tips.show(this.$i18n.tc('receive_reward_tips_text'));
					} else if (response.code === 9001) {
						this.$refs.tips.show('Received already');
					}
				})
		},
		openConfirmOrderWindow: function (productId) {
			if (!this.hasLogin) {
				this.$refs.header.openLoginWindow();
				return;
			}

			if (isEmpty(this.$cache.getRoleInfo())) {
				this.$refs.userInfo.openRoleChooseWindow();
				return;
			}
			$("#confirmOrderWindow").bPopup();
		},
	}

}
</script>

<style>
/* pc端 */
@keyframes mymove3 {

	0% {
		transform: scale(1);
	}

	45% {
		/* transform: scale(0.6); */
	}

	50% {
		transform: scale(0.9);
	}

}

@keyframes shake {
	0% {
		transform: translateX(0);
	}

	25% {
		transform: translateX(-10px);
	}

	50% {
		transform: translateX(10px);
	}

	75% {
		transform: translateX(-10px);
	}

	100% {
		transform: translateX(10px);
	}
}

.button_active {
	-webkit-filter: grayscale(100%);
	filter: grayscale(100%);
}

@media (min-width: 768px) {
	.position-war {
		padding: 0rem !important;
		width: 15rem !important;
		margin-top: .3125rem;
		min-height: 8rem;
		padding: .375rem;
		background: #FFFFFF;
		box-shadow: -0.025rem 0rem .25rem .0125rem rgba(0, 0, 0, 0.16);
		border-radius: .125rem .125rem .125rem .125rem;
	}

	.icon {
		/* position: absolute; */
		width: 15rem;
		height: 1.275rem;
		background: url(../assets/warorderimg/kv.png) no-repeat;
		background-size: 100% 100%;
	}

	.Purchased {
		position: relative;
		overflow: hidden;
		margin: auto;
		width: 1rem;
		height: 1.275rem;
		/* position: absolute; */
	}

	.Purchased img {
		position: absolute;
		left: -.5rem;
		top: -.5rem;
		width: 2rem;
		height: 2rem;
	}

	.Purchased img.animation {
		animation: shake 0.5s;
		/* 抖动的持续时间 */
		animation-iteration-count: infinite;
		/* 动画重复次数 */
	}

	.conter .days {
		width: .275rem;
		height: 10.7rem;
		background: url(../assets/warorderimg/days.png) no-repeat;
		background-size: 100% 100%;
	}

	.Purchased p {
		color: #fff;
		position: absolute;
		bottom: 0.1rem;
		left: .1rem;
		text-align: center;
		line-height: .2875rem;
		width: .825rem;
		height: .2875rem;
		font-size: .15rem;
		background: #C1C1C1;
		box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.6), inset -1px -1px 1px 1px rgba(0, 0, 0, 0.2);
		border-radius: 1.25rem 1.25rem 1.25rem 1.25rem;
	}

	.Purchased p.animation {
		animation: mymove3 1s infinite;
		background: red;
	}

	.conter {
		display: flex;
		justify-content: space-between;
		margin: auto;
		margin-top: .15rem;
		width: 6.95rem;
		height: 10.7rem;
	}

	.conter-left {
		position: relative;
		padding-top: .1625rem !important;
		width: 2.1rem;
		min-height: 8rem;
	}

	.Daily {
		margin: auto;
		text-align: center;
		line-height: .35rem;
		width: 1.7875rem;
		height: .35rem;
		color: #fff;
		background: #FFDA47;
		border-radius: 1.25rem 1.25rem 1.25rem 1.25rem;
		border: 1px solid #EEEEEE;
	}

	.conter-left ul {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		margin-top: .2625rem;
		margin-left: 0rem !important;
		width: 100%;
		height: 8.6rem;
	}

	.conter-left ul li {
		width: 2.1rem !important;
		height: .8875rem !important;
		border-radius: .1rem .1rem .1rem .1rem;
	}

	.conter-left ul li:nth-child(1) {
		background: url(../assets/warorderimg/day01.png) no-repeat;
		background-size: 100% 100%;
	}

	.conter-left ul li:nth-child(2) {
		background: url(../assets/warorderimg/day02.png) no-repeat;
		background-size: 100% 100%;
	}

	.conter-left ul li:nth-child(3) {
		background: url(../assets/warorderimg/day03.png) no-repeat;
		background-size: 100% 100%;
	}

	.conter-left ul li:nth-child(4) {
		background: url(../assets/warorderimg/day04.png) no-repeat;
		background-size: 100% 100%;
	}

	.conter-left ul li:nth-child(5) {
		background: url(../assets/warorderimg/day05.png) no-repeat;
		background-size: 100% 100%;
	}

	.conter-left ul li:nth-child(6) {
		background: url(../assets/warorderimg/day06.png) no-repeat;
		background-size: 100% 100%;
	}

	.conter-left ul li:nth-child(7) {
		background: url(../assets/warorderimg/day07.png) no-repeat;
		background-size: 100% 100%;
	}

	.active {
		position: relative;
		width: 100%;
		height: 100%;
		background: #000000 !important;
		border-radius: .1rem .1rem .1rem .1rem;
		opacity: 0.6 !important;
	}

	.active img {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		/* 或者左右居中 */
		left: 50%;
		transform: translate(-50%, -50%);
	}


	.conter-right {
		position: relative;
		padding-top: .1625rem !important;
		width: 3.925rem;
		min-height: 8rem;
	}

	.Super {
		margin: auto;
		text-align: center;
		line-height: .35rem;
		width: 1.7875rem;
		height: .35rem;
		color: #fff;
		background: linear-gradient(to right, #FC9338 0%, #D1AEAE 100%);
		border-radius: 1.25rem 1.25rem 1.25rem 1.25rem;
		border: 1px solid #EEEEEE;
	}

	.conter-right ul {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		margin-top: .2625rem;
		margin-left: 0rem !important;
		width: 100%;
		height: 8.6rem;
	}

	.conter-right ul li {
		width: 3.925rem !important;
		height: .8875rem !important;
	}

	.conter-right ul li:nth-child(1) {
		background: url(../assets/warorderimg/super01.png) no-repeat;
		background-size: 100% 100%;
	}

	.conter-right ul li:nth-child(2) {
		background: url(../assets/warorderimg/super02.png) no-repeat;
		background-size: 100% 100%;
	}

	.conter-right ul li:nth-child(3) {
		background: url(../assets/warorderimg/super03.png) no-repeat;
		background-size: 100% 100%;
	}

	.conter-right ul li:nth-child(4) {
		background: url(../assets/warorderimg/super04.png) no-repeat;
		background-size: 100% 100%;
	}

	.conter-right ul li:nth-child(5) {
		background: url(../assets/warorderimg/super05.png) no-repeat;
		background-size: 100% 100%;
	}

	.conter-right ul li:nth-child(6) {
		background: url(../assets/warorderimg/super06.png) no-repeat;
		background-size: 100% 100%;
	}

	.conter-right ul li:nth-child(7) {
		background: url(../assets/warorderimg/super07.png) no-repeat;
		background-size: 100% 100%;
	}

	.active_no {
		filter: grayscale(0%) !important;
	}
}

/* 手机端 */
@media (max-width: 767px) {
	.box-waro {
		min-height: 22.92rem !important;
	}

	.conter .days {
		width: .5867rem;
		height: 16.4267rem;
		background: url(../assets/warorderimg/daysmo.png) no-repeat;
		background-size: 100% 100%;
	}

	.position-war {
		padding: 0rem !important;
		width: 10rem !important;
		margin-top: .3125rem;
		min-height: 8rem;
		padding: .375rem;
		background: #FFFFFF;
		box-shadow: -0.025rem 0rem .25rem .0125rem rgba(0, 0, 0, 0.16);
		border-radius: .125rem .125rem .125rem .125rem;
	}

	.icon {
		width: 10rem;
		height: 2.72rem;
		background: url(../assets/warorderimg/kv1.png) no-repeat;
		background-size: 100% 100%;
	}

	.Purchased {
		position: relative;
		margin: auto;
		padding-top: 1.12rem;
		width: 4.6667rem;
		height: 1.5467rem;
		/* position: absolute; */
	}

	.Purchased img {
		animation: shake 0.5s;
		/* 抖动的持续时间 */
		animation-iteration-count: infinite;
		/* 动画重复次数 */
		position: absolute;
		left: -1rem;
		top: 0rem;
		width: 4rem;
		height: 4rem;
	}

	.Purchased p {
		color: #fff;
		z-index: 999;
		animation: mymove3 1s infinite;
		position: absolute;
		bottom: 0.3rem;
		left: 2rem;
		text-align: center;
		line-height: .5333rem;
		width: 2rem;
		height: .5333rem;
		font-size: .32rem;
		background: #C1C1C1;
		box-shadow: 0rem 0rem .1067rem .0267rem rgba(0, 0, 0, 0.6), inset -0.0267rem -0.0267rem .0267rem .0267rem rgba(0, 0, 0, 0.2);
		border-radius: 2.6667rem 2.6667rem 2.6667rem 2.6667rem;
	}

	.conter {
		display: flex;
		justify-content: space-between;
		margin: auto;
		margin-top: .15rem;
		width: 9.0133rem;
		height: 16.4267rem;
	}

	.conter-left {
		position: relative;
		padding-top: .1625rem !important;
		width: 3.6rem;
		min-height: 8rem;
	}

	.Daily {
		font-size: .32rem;
		margin: auto;
		text-align: center;
		line-height: .7467rem;
		width: 3.3333rem;
		height: .7467rem;
		color: #fff;
		background: #FFDA47;
		border-radius: 1.25rem 1.25rem 1.25rem 1.25rem;
		border: 1px solid #EEEEEE;
	}

	.conter-left ul {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		margin-top: .2625rem;
		margin-left: 0rem !important;
		width: 100%;
		height: 15.3rem;
	}

	.conter-left ul li {
		width: 3.6rem !important;
		height: 1.52rem !important;
		border-radius: .2133rem .2133rem .2133rem .2133rem;
	}

	.conter-left ul li:nth-child(1) {
		background: url(../assets/warorderimg/day01.png) no-repeat;
		background-size: 100% 100%;
	}

	.conter-left ul li:nth-child(2) {
		background: url(../assets/warorderimg/day02.png) no-repeat;
		background-size: 100% 100%;
	}

	.conter-left ul li:nth-child(3) {
		background: url(../assets/warorderimg/day03.png) no-repeat;
		background-size: 100% 100%;
	}

	.conter-left ul li:nth-child(4) {
		background: url(../assets/warorderimg/day04.png) no-repeat;
		background-size: 100% 100%;
	}

	.conter-left ul li:nth-child(5) {
		background: url(../assets/warorderimg/day05.png) no-repeat;
		background-size: 100% 100%;
	}

	.conter-left ul li:nth-child(6) {
		background: url(../assets/warorderimg/day06.png) no-repeat;
		background-size: 100% 100%;
	}

	.conter-left ul li:nth-child(7) {
		background: url(../assets/warorderimg/day07.png) no-repeat;
		background-size: 100% 100%;
	}

	.active {
		position: relative;
		width: 100%;
		height: 100%;
		background: #000000 !important;
		border-radius: .1rem .1rem .1rem .1rem;
		opacity: 0.6 !important;
	}

	.active img {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		/* 或者左右居中 */
		left: 50%;
		transform: translate(-50%, -50%);
	}


	.conter-right {
		position: relative;
		padding-top: .1625rem !important;
		width: 3.925rem;
		min-height: 8rem;
	}

	.Super {
		font-size: .32rem;
		margin: auto;
		text-align: center;
		line-height: .7467rem;
		width: 3.3333rem;
		height: .7467rem;
		color: #fff;
		background: linear-gradient(to right, #FC9338 0%, #D1AEAE 100%);
		border-radius: 1.25rem 1.25rem 1.25rem 1.25rem;
		border: 1px solid #EEEEEE;
	}

	.conter-right ul {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		margin-top: .2625rem;
		margin-left: 0rem !important;
		width: 100%;
		height: 15.3rem;
	}

	.conter-right ul li {
		width: 4.2667rem !important;
		height: 1.52rem !important;
		border-radius: .14rem .14rem .14rem .14rem !important;
	}

	.conter-right ul li:nth-child(1) {
		background: url(../assets/warorderimg/mo_super01.png) no-repeat;
		background-size: 100% 100%;
	}

	.conter-right ul li:nth-child(2) {
		background: url(../assets/warorderimg/mo_super02.png) no-repeat;
		background-size: 100% 100%;
	}

	.conter-right ul li:nth-child(3) {
		background: url(../assets/warorderimg/mo_super03.png) no-repeat;
		background-size: 100% 100%;
	}

	.conter-right ul li:nth-child(4) {
		background: url(../assets/warorderimg/mo_super04.png) no-repeat;
		background-size: 100% 100%;
	}

	.conter-right ul li:nth-child(5) {
		background: url(../assets/warorderimg/mo_super05.png) no-repeat;
		background-size: 100% 100%;
	}

	.conter-right ul li:nth-child(6) {
		background: url(../assets/warorderimg/mo_super06.png) no-repeat;
		background-size: 100% 100%;
	}

	.conter-right ul li:nth-child(7) {
		background: url(../assets/warorderimg/mo_super07.png) no-repeat;
		background-size: 100% 100%;
	}

	.active_no {
		filter: grayscale(0%) !important;
	}


}
</style>